import React, { useState } from "react";
import "./FilosofiaCorporativa.css";
import { motion } from "framer-motion";
import { FaBullseye, FaEye, FaHandsHelping, FaChevronDown } from "react-icons/fa";

const FilosofiaCorporativa = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const items = [
    {
      title: "MISIÓN",
      content: "Nuestra misión es seguir siendo referentes en la venta de productos gastronómicos de alta calidad, brindando una experiencia única que supere las expectativas de nuestros clientes en cada detalle.",
      icon: <FaBullseye className="filosofia-icon" />
    },
    {
      title: "VISIÓN",
      content: "Nuestra visión es expandirnos, alcanzando mayor visibilidad y reconocimiento, manteniendo la excelencia en nuestra producción y sosteniendo los valores que nos definen como empresa.",
      icon: <FaEye className="filosofia-icon" />
    },
    {
      title: "VALORES",
      content: (
        <ul className="mt-3">
          <li><strong>COMPROMISO</strong> con la máxima calidad:</li>
          <ul className="mb-2">
            <li>En los productos</li>
            <li>En los servicios</li>
            <li>En los procesos</li>
          </ul>
          <li><strong>TRANSPARENCIA</strong> en cada transacción.</li>
          <li><strong>RESPONSABILIDAD</strong> en las entregas.</li>
          <li><strong>INNOVACIÓN</strong> y mejora de nuestros productos.</li>
          <li><strong>COLABORACIÓN</strong> de todo nuestro personal, trabajamos unidos en equipo para lograr el éxito común.</li>
          <li><strong>PREDISPOSICIÓN</strong> para la escucha activa de nuestros clientes.</li>
          <li><strong>DISCIPLINA</strong> sólida en nuestro equipo de trabajo, que ha sido nuestra seña de identidad durante más de 40 años.</li>
        </ul>
      ),
      icon: <FaHandsHelping className="filosofia-icon" />
    }
  ];

  return (
    <section className="filosofia-section">
      <div className="container">
        <div className="filosofia-grid">
          {items.map((item, index) => (
            <div
              key={index}
              className={`filosofia-item ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggleItem(index)}
              style={{ cursor: "pointer" }}
            >
              {activeIndex !== index && item.icon}
              {activeIndex !== index && <h3>{item.title}</h3>}
              {activeIndex !== index && <FaChevronDown className="arrow-icon" />}
              <motion.div
                className="filosofia-content"
                initial={{ maxHeight: 0, opacity: 0 }}
                animate={activeIndex === index ? { maxHeight: "500px", opacity: 1 } : { maxHeight: 0, opacity: 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
              >
                {item.content}
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FilosofiaCorporativa;
